import { map } from '@codeArt/utils/promise';
import { type } from '../utils/common';

const _ = require("lodash");
function Context(){

    const _members = {};

    this.register = (name,member)=>{    //向上下文中注册成员
        let m = _members[name];
        if(!m) m = {};
        _members[name] = {...m,...member};
    }

    this.get=()=>{  //获得一个上下文示例
        return {
            ..._members
        }
    }

}

export {Context};